<template>
  <button
    class="trail-node flex flex-col items-center transition-transform duration-150"
    :class="[
      lesson.status === 'locked' ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:scale-110',
      lesson.status === 'current' ? 'scale-105' : ''
    ]"
    :title="lesson.status === 'locked' ? lesson.lockMessage : ''"
    :data-lesson-status="lesson.status"
    @click="$emit('select', lesson)"
  >
    <!-- Node circle -->
    <div
      class="relative rounded-full flex items-center justify-center font-bold shadow-md
             w-12 h-12 sm:w-14 sm:h-14 text-sm sm:text-base"
      :class="nodeClasses"
    >
      <!-- Pulsing ring for current -->
      <div
        v-if="lesson.status === 'current'"
        class="absolute inset-0 rounded-full animate-ping opacity-30"
        :class="ringClass"
      />
      <MTIcon v-if="lesson.status === 'completed'" name="trophy" :size="20" />
      <MTIcon v-else-if="lesson.status === 'current'" name="play" :size="20" />
      <MTIcon v-else-if="lesson.status === 'locked'" name="lock" :size="16" />
      <span v-else-if="lesson.status === 'skipped'" class="font-black text-base">!</span>
      <span v-else>{{ index + 1 }}</span>
    </div>

    <!-- Stars -->
    <div class="flex gap-0.5 mt-1">
      <MTIcon
        v-for="i in 3"
        :key="i"
        name="star"
        :size="11"
        :class="i <= lesson.stars ? 'text-yellow-400' : 'text-gray-300'"
      />
    </div>

    <!-- Label -->
    <div
      class="text-xs text-center mt-1 leading-tight line-clamp-2 max-w-[90px]"
      :class="lesson.status === 'locked' ? 'text-red-600 font-bold' : 'text-gray-700 font-medium'"
    >
      {{ lesson.title }}
    </div>
  </button>
</template>

<script setup>
import { computed } from 'vue';
import MTIcon from '@/components/ui/MTIcon.vue';

const props = defineProps({
  lesson: { type: Object, required: true },
  index: { type: Number, required: true }
});

defineEmits(['select']);

const nodeClasses = computed(() => {
  switch (props.lesson.status) {
    case 'completed':
      return 'bg-amber-500 text-white shadow-amber-500/30 shadow-lg';
    case 'current':
      return 'bg-blue-500 text-white ring-4 ring-blue-200';
    case 'locked':
      return 'bg-red-500 text-white shadow-red-500/30 shadow-lg';
    case 'skipped':
      return 'bg-orange-100 text-orange-600 border-2 border-orange-400 border-dashed';
    default:
      return 'bg-white text-gray-600 border-2 border-gray-300';
  }
});

const ringClass = computed(() => {
  return props.lesson.status === 'current' ? 'bg-blue-400' : '';
});
</script>
